// O worker de ZIP pode levar minutos para pegar o job. Repete o pedido até o ZIP
// ficar pronto, para o usuário não precisar clicar de novo.
export const waitBatchZipUrl = async (
  requestZip,
  { intervalMs = 10000, timeoutMs = 20 * 60 * 1000, isCanceled = () => false, onWaiting = () => {} } = {}
) => {
  const deadline = Date.now() + timeoutMs;

  const attempt = async () => {
    let response = null;
    try {
      response = await requestZip();
    } catch (error) {
      if (error.status !== 409) throw error;
    }

    if (response?.status === 'completed' && response.download_url) return response.download_url;
    if (isCanceled() || Date.now() + intervalMs > deadline) return null;

    onWaiting();
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
    return isCanceled() ? null : attempt();
  };

  return attempt();
};
